// extracted by mini-css-extract-plugin
export default {"dataman70InstrumentPage":"dataman70InstrumentPage-OJ97_","realTimeState":"realTimeState-AWCIy","label":"label-dLwcI","readerState":"readerState-Lp0RT","on":"on-kFHW2"};